import { render, staticRenderFns } from "./Pentagon.vue?vue&type=template&id=5a3d74e3&"
import script from "./Pentagon.vue?vue&type=script&lang=js&"
export * from "./Pentagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports